/**
 * Class that handles clean up between level switches. Specifically,
 * it handles saving any unsaved project changes, destroying the project manager
 * once those saves are done, then calling out to a reset function provided by the lab.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var LevelChangeManager = /** @class */ (function () {
    function LevelChangeManager(handleLevelReset) {
        this.handleLevelReset = handleLevelReset;
    }
    /**
     * Change levels and handle level reset.
     * @param existingProject The current project to save before changing levels (if it has changed).
     * @param existingProjectManager The current project manager to clean up before changing levels.
     * @param startSources Start sources for the new level.
     * @param levelId The level id of the new level.
     * @param scriptId The script id of the new level (optional).
     */
    LevelChangeManager.prototype.changeLevel = function (existingProject, existingProjectManager, startSources, levelId, scriptId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!existingProjectManager.hasUnsavedChanges()) return [3 /*break*/, 2];
                        // Force a save with the current code before changing levels if there are unsaved changes.
                        return [4 /*yield*/, existingProjectManager.save(existingProject, true)];
                    case 1:
                        // Force a save with the current code before changing levels if there are unsaved changes.
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        // Clear out any remaining enqueued saves from the existing project manager.
                        existingProjectManager.destroy();
                        // Reset the level.
                        return [4 /*yield*/, this.handleLevelReset(startSources, levelId, scriptId)];
                    case 3:
                        // Reset the level.
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return LevelChangeManager;
}());
export default LevelChangeManager;
